import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "card-body py-3 mb-10" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "card-title align-items-start flex-column mb-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("         ")
const _hoisted_7 = { class: "card-label fw-bolder fs-3 " }
const _hoisted_8 = { class: " mb-2" }
const _hoisted_9 = { class: " mb-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" to retro qualify and enjoy your Marketing benefits starting TODAY. ")
const _hoisted_11 = {
  key: 0,
  class: " mb-2"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_13 = { class: " mb-2" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: " mb-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("          Your account ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" currently has ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" points and ranked ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_20 = { class: " mb-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("          You need ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" more points away to become ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("!")
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: " mb-2" }, "          Upgrade rank by buying more products and encouraging your group to do the same to develop more customers. Happy Networking!!!", -1)
const _hoisted_25 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6"
}
const _hoisted_26 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\">Important Notice</h4><div class=\"fs-6 text-gray-600\"><a href=\"#/dashboard/mycoverage\">You may now RENEW your existing coverage through My Coverage menu</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_font = _resolveComponent("font")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      (_ctx.pt != 'ovi')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ECP_EDP_DashboardNavigator)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", _hoisted_5, [
            _hoisted_6,
            _createVNode("span", _hoisted_7, "Welcome " + _toDisplayString(_ctx.user.fname + ' ' + _ctx.user.lname) + "!", 1)
          ]),
          _withDirectives(_createVNode("p", _hoisted_8, [
            _createTextVNode("           Your " + _toDisplayString(_ctx.r2meLinkLabel) + " link is ", 1),
            _createVNode("a", {
              href: _ctx.r2meLink,
              target: "_blank",
              class: " mb-0"
            }, [
              _createVNode(_component_font, { color: "red" }, {
                default: _withCtx(() => [
                  _createVNode("b", null, [
                    _createVNode("u", null, _toDisplayString(_ctx.r2meLink), 1)
                  ])
                ]),
                _: 1
              })
            ], 8, ["href"])
          ], 512), [
            [_vShow, _ctx.ecp_welcome_data.isShowR2MELink]
          ]),
          _withDirectives(_createVNode("p", _hoisted_9, [
            _createTextVNode("           You did not qualify Last Month (" + _toDisplayString(_ctx.ecp_welcome_data.lastMonth) + ")! To enjoy your Marketing Plan benefits for this month. ", 1),
            _createVNode("button", {
              type: "button",
              class: "btn btn-primary er fs-6 px-8 py-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showRetroPMAPage();})
            }, "Purchase Double PMA"),
            _hoisted_10
          ], 512), [
            [_vShow, _ctx.ecp_welcome_data.isShowRetroPMAButton]
          ]),
          (_ctx.isShowQualifiedMessage)
            ? (_openBlock(), _createBlock("p", _hoisted_11, [
                _hoisted_12,
                _createVNode("b", null, "PMA Reminder for " + _toDisplayString(_ctx.user.usid) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("p", _hoisted_13, "          " + _toDisplayString(_ctx.ecp_welcome_data.unilevelMaintenancePromptMessage2), 1),
          _withDirectives(_createVNode("p", { class: " mb-2" }, " Your Prime Pair is active from " + _toDisplayString(_ctx.ecp_welcome_data.ext_f) + " to " + _toDisplayString(_ctx.ecp_welcome_data.ext_t), 513), [
            [_vShow, _ctx.ecp_welcome_data.ext_f !== 'null' && _ctx.ecp_welcome_data.ext_t !== 'null' && _ctx.ecp_welcome_data.ext_f !== undefined && _ctx.ecp_welcome_data.ext_t !== undefined]
          ]),
          (_ctx.ecp_welcome_data.currentRank != 'GA' && _ctx.ecp_welcome_data.currentRank != 'GM' && _ctx.ecp_welcome_data.currentRank != 'RB' && _ctx.ecp_welcome_data.currentRank != 'DM')
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("p", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("b", null, "(" + _toDisplayString(_ctx.ecp_welcome_data.usid) + ")", 1),
                  _hoisted_17,
                  _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.ecp_welcome_data.currentPV).toFixed(4))), 1),
                  _hoisted_18,
                  _createVNode("b", null, _toDisplayString(_ctx.ecp_welcome_data.currentRank), 1),
                  _hoisted_19
                ]),
                _createVNode("p", _hoisted_20, [
                  _hoisted_21,
                  _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.ecp_welcome_data.awaypv).toFixed(4))), 1),
                  _hoisted_22,
                  _createVNode("b", null, _toDisplayString(_ctx.ecp_welcome_data.nextRank), 1),
                  _hoisted_23
                ]),
                _hoisted_24
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.renewBannerFlag && _ctx.pt==='ovi')
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _createVNode("span", _hoisted_26, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
              ]),
              _hoisted_27
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
}